module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.openEditor || !_vm.edition) ? _c('embed-text', {
    staticClass: "description",
    attrs: {
      "text": (_vm.module.description || '').trim() || _vm.$t('groupPages.modules.description.noDescription')
    }
  }) : _vm._e(), (_vm.openEditor && _vm.edition) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("groupManagement.description.title")))]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.module.description),
      expression: "module.description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.module.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.module, "description", $event.target.value)
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary pright",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.save')))]), _c('div', {
    staticClass: "cf"
  })]) : _vm._e(), (_vm.openEditor && !_vm.edition) ? [_c('div', {
    staticClass: "btn btn-primary pright",
    on: {
      "click": _vm.toggleEdition
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.edit')))]), _c('div', {
    staticClass: "cf"
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2535eaeb","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageDescription.vue
// module id = 1253
// module chunks = 2